import { ComponentWithAs } from '@chakra-ui/react';
import { IIconProps, Icon } from '~/components/Icon';

export const CheckboxIcon: ComponentWithAs<'svg', IIconProps> = (
  props: any,
) => (
  <Icon
    data-testid="checkbox-icon"
    aria-label="checkbox icon"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.788 1.125C17.788 0.503678 17.2843 0 16.663 0H2.53124L2.39236 0.00374541C1.05898 0.0758458 0 1.17987 0 2.53124V21.4687L0.00374541 21.6075C0.0758458 22.9409 1.17987 23.9999 2.53124 23.9999H21.4687L21.6075 23.9962C22.9409 23.9241 23.9999 22.82 23.9999 21.4687V10.8187L23.9948 10.7103C23.9402 10.1398 23.4597 9.69366 22.8749 9.69366C22.2536 9.69366 21.7499 10.1973 21.7499 10.8187V21.4687L21.7442 21.5253C21.718 21.6535 21.6046 21.7499 21.4687 21.7499H2.53124L2.47456 21.7442C2.3464 21.718 2.24999 21.6046 2.24999 21.4687V2.53124L2.25571 2.47456C2.28193 2.3464 2.39533 2.24999 2.53124 2.24999H16.663L16.7713 2.24484C17.3418 2.19033 17.788 1.70977 17.788 1.125ZM23.5238 0.580966C23.0162 0.222618 22.3142 0.343582 21.9559 0.851147L10.8262 15.8639L5.47617 9.0549L5.40053 8.96805C5.00475 8.55758 4.35453 8.50549 3.89651 8.86537C3.40796 9.24924 3.32311 9.95647 3.70698 10.445L9.99036 18.4418L10.0633 18.526C10.5448 19.0301 11.3814 18.9799 11.794 18.3956L23.7939 2.14884L23.8522 2.05736C24.1367 1.55988 24.0015 0.918235 23.5238 0.580966Z"
      fill="currentColor"
    />
  </Icon>
);
